const theme = {
  colors: {
    primary: '#2563EB', primaryLight: '#EFF6FF', primarySoft: '#DBEAFE', primaryDark: '#1D4ED8',
    secondary: '#64748B', background: '#F4F6F8', paper: '#FFFFFF', neutral: '#F8FAFC', bglogin: '#0F3D75',
    text: '#1E293B', texto: '#1E293B', textSecondary: '#64748B', textMuted: '#94A3B8', textLight: '#FFFFFF',
    label: '#475569', icon: '#64748B', tertiary: '#F8FAFC', medium: '#CBD5E1',
    border: '#E2E8F0', borderStrong: '#CBD5E1', borderRadius: '12px',
    textHover: '#1D4ED8', iconHover: '#2563EB', backgroundHover: '#EFF6FF', borderHover: '#93C5FD',
    textActive: '#1D4ED8', iconActive: '#2563EB', backgroundActive: '#EFF6FF', borderActive: '#BFDBFE',
    success: '#16A34A', warning: '#D97706', error: '#DC2626', shadow: 'rgba(15, 23, 42, 0.12)',
    modalOver: 'rgba(15, 23, 42, 0.56)', btnColor: '#FFFFFF',
    btnText: '#475569', btnBackground: '#F1F5F9', btnboder: '1px solid #E2E8F0', btnIcon: '#FFFFFF',
    btnPadding: '7px 12px', btnFontSize: '13px', btnBorderRadius: '10px', btnBackgroundActive: '#FFFFFF',
    btnboderActive: '1px solid #CBD5E1', btnBorderRadiusHover: '10px', textMail: '#2563EB',
    borderMail: '1px solid #DBEAFE', btnBorderRadiusMail: '8px',
  },
  typography: {
    fontFamily: "'Inter Tight', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    weightRegular: 400, weightMedium: 500, weightSemibold: 600, weightBold: 700,
  },
  radius: { sm: '8px', md: '10px', lg: '12px', xl: '16px' },
  shadows: {
    xs: '0 1px 2px rgba(15, 23, 42, 0.05)', sm: '0 4px 12px rgba(15, 23, 42, 0.06)',
    md: '0 12px 28px rgba(15, 23, 42, 0.10)', focus: '0 0 0 3px rgba(37, 99, 235, 0.14)',
  },
  icons: {
    setaCima: (color = '#475569') => `url("data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${color}' stroke-width='2'><path d='M6 9l6 6 6-6'/></svg>`)}")`,
    setaBaixo: (color = '#475569') => `url("data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${color}' stroke-width='2'><path d='M6 15l6-6 6 6'/></svg>`)}")`,
  },
};

export default theme;
